import React, { useEffect, useState } from 'react';

const Jobs = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-lg-8 text-center">
          <h1 className="mb-4">Career Opportunities</h1>
          
          <div className="card shadow-sm">
            <div className="card-body py-5">
              <i className="fas fa-briefcase fa-3x text-muted mb-4"></i>
              <h3 className="mb-3">No Current Openings</h3>
              <p className="lead text-muted mb-4">
                We currently do not have any new openings available. However, we are always 
                interested in hearing from talented individuals who are passionate about 
                what we do.
              </p>
              
              <div className="mb-4">
                <h5>Stay Connected</h5>
                <p className="text-muted">
                  If you're interested in future opportunities with Vegbox, please feel free 
                  to send us your resume and a cover letter. We'll keep your information on 
                  file and reach out when a suitable position becomes available.
                </p>
              </div>

              <div className="contact-info">
                <p className="mb-2">
                  <strong>Email your application to:</strong>
                </p>
                <p className="mb-3">
                  <a href="mailto:vegboxgmbh@gmail.com" className="btn btn-outline-success">
                    <i className="fas fa-envelope me-2"></i>vegboxgmbh@gmail.com
                  </a>
                </p>
              </div>

              <div className="mt-4">
                <small className="text-muted">
                  We are an equal opportunity employer committed to diversity and inclusion.
                </small>
              </div>
            </div>
          </div>
          
          <div className="mt-4">
            <p className="text-muted">
              Want to learn more about our company? 
              <a href="/about-us" className="text-decoration-none ms-1">Visit our About page</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Jobs;